import React from 'react';
import {useTranslation} from 'react-i18next';
import {makeStyles} from '@material-ui/core/styles';
import {Button} from '@material-ui/core';
import {Link} from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        textTransform: 'none'
    }
}));

function FormButtons({handleCancel, handleCreateUser, disableCreateButton, buttonText}) {
    const classes = useStyles();
    const {t} = useTranslation();

    return (
        <div className="info_button-container" data-test="info_button-container">
            <div className="button-container">
                <Button
                    size="small"
                    className={`${classes.button} ${disableCreateButton ? "disabled-button" : ""}`}
                    data-test="createuser-button"
                    variant="outlined"
                    style={{backgroundColor: '#162436', color: '#fff', fontSize: 12, cursor: "pointer"}}
                    disabled={disableCreateButton}
                    onClick={handleCreateUser}
                >
                    {buttonText}
                </Button>
                <Link to={{pathname: "/management/user-management/users"}} style={{textDecoration: 'none'}}>
                    <Button
                        size="small"
                        className={classes.button}
                        data-test="cancel-button"
                        variant="outlined"
                        style={{fontSize: 12}}
                        onClick={handleCancel}
                    >
                        {t('CONTENT.USER.CANCEL')}
                    </Button>
                </Link>
            </div>
        </div>
    );
}

export default FormButtons;
